// src/pages/Pulti.tsx
import { Tab } from '@headlessui/react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import HeroSection from '@/components/HeroSection';
import SectionHeading from '@/components/SectionHeading';
import Gallery from '@/components/Gallery';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const Pulti = () => {
  const categories = [
    { id: 'abk-stone-pulti', name: 'ABK stone pulti' },
    { id: 'granit-pulti', name: 'Granit pulti' },
    { id: 'quartz-pulti', name: 'Quartz pulti' },
  ];

  const categoryData = {
    'abk-stone-pulti': {
      title: 'ABK stone pulti',
      description: 'Inovativni ABK stone pulti.',
      images: [
        { 
          src: 'https://images.unsplash.com/photo-1600607687710-058c7639a4b2?q=80&w=2070', 
          alt: 'ABK stone pulti' 
        },
        { 
          src: 'https://images.unsplash.com/photo-1588854337221-4cf9fa96059c?q=80&w=2070', 
          alt: 'ABK stone pult v kuhinji' 
        },
        { 
          src: 'https://images.unsplash.com/photo-1600607687206-4e5aeb8c22da?q=80&w=2070', 
          alt: 'ABK stone pult v moderni kuhinji' 
        },
      ]
    },
    'granit-pulti': {
      title: 'Granit pulti',
      description: 'Granitni pulti za brezčasen videz.',
      images: [
        { 
          src: 'https://images.unsplash.com/photo-1494752113016-ca48410d72f2?q=80&w=2068', 
          alt: 'Granitni pult' 
        },
        { 
          src: 'https://images.unsplash.com/photo-1600566752747-8bc5c0d61d07?q=80&w=2070', 
          alt: 'Granitni pult v kuhinji' 
        },
        { 
          src: 'https://images.unsplash.com/photo-1599656892233-54e4a66e6da1?q=80&w=2069', 
          alt: 'Granitni pult v moderni kuhinji' 
        },
      ]
    },
    'quartz-pulti': {
      title: 'Quartz pulti',
      description: 'Kvarčni pulti za moderen slog.',
      images: [
        { 
          src: 'https://images.unsplash.com/photo-1493809214328-a3c89128bc54?q=80&w=2070', 
          alt: 'Kvarčni pult' 
        },
        { 
          src: 'https://images.unsplash.com/photo-1556908397-daad441c6578?q=80&w=2070', 
          alt: 'Kvarčni pult v kuhinji' 
        },
        { 
          src: 'https://images.unsplash.com/photo-1556909172-8c2f041fca1e?q=80&w=2070', 
          alt: 'Kvarčni pult v luksuzni kuhinji' 
        },
      ]
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar />
      
      <main className="pt-16">
        <HeroSection 
          title="Pulti za kuhinje in kopalnice"
          subtitle="Eleganca in funkcionalnost v enem"
          imageSrc="https://images.unsplash.com/photo-1599656892435-0f704e3d910b?q=80&w=2069"
        />

        <section className="py-16">
          <div className="container-custom">
            <SectionHeading 
              title="Naša ponudba pultov"
              subtitle="Vrhunski pulti za kuhinjo in kopalnico po vaši meri"
            />
            
            <Tab.Group>
              <Tab.List className="flex space-x-1 rounded-xl bg-stone-100 p-1 mb-8">
                {categories.map((category) => (
                  <Tab
                    key={category.id}
                    className={({ selected }) =>
                      `w-full rounded-lg py-3 text-sm font-medium leading-5 
                      ${
                        selected
                          ? 'bg-white shadow text-stone-800'
                          : 'text-stone-600 hover:bg-white/[0.12] hover:text-stone-800'
                      }`
                    }
                  >
                    {category.name}
                  </Tab>
                ))}
              </Tab.List>
              <Tab.Panels className="mt-2">
                {Object.entries(categoryData).map(([id, data]) => (
                  <Tab.Panel
                    key={id}
                    className="rounded-xl p-3"
                  >
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.5 }}
                    >
                      <div className="mb-10">
                        <h3 className="text-2xl font-bold text-stone-800 mb-3">{data.title}</h3>
                        <p className="text-lg text-stone-600 mb-6">{data.description}</p>
                        <Gallery images={data.images} />
                        <div className="mt-8 flex justify-center">
                          <Button asChild>
                            <a href="/kontakt" className="flex items-center gap-2">
                              Zahtevaj ponudbo <ArrowRight size={16} />
                            </a>
                          </Button>
                        </div>
                      </div>
                    </motion.div>
                  </Tab.Panel>
                ))}
              </Tab.Panels>
            </Tab.Group>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Pulti;